export default __webpack_public_path__ + "static/media/microphone.7d25ce4b.svg";